import styled from 'styled-components';
import { Drag } from 'ui/icons/action/Drag';
import { body2, borderRadius, colors, duration, easing, spacing, subtleShadow } from 'ui/theme';

export const DragGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${spacing.base};
`;

export const IndexChip = styled.p`
  display: flex;
  margin: 0;
  justify-content: center;
  align-items: center;
  background-color: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.full};
  color: ${colors.textSecondary};
  height: ${spacing.plusHalf};
  width: ${spacing.plusHalf};
  transition: all ${duration.short} ${easing.entrance};
`;

export const BoxRow = styled.div<{ withCounter: boolean }>`
  display: grid;
  grid-template-columns: ${({ withCounter }) => (withCounter ? `${spacing.plusHalf} 2fr` : `1fr`)};
  column-gap: ${spacing.base};
  align-items: center;
  border-radius: ${spacing.half};
  border: ${spacing.single} solid ${colors.grey5};
  background: ${colors.white};
  padding: ${spacing.threeQuarter} ${spacing.base};
  ${subtleShadow};
  transition: all ${duration.short} ${easing.entrance};

  &:hover {
    background: ${colors.backgroundPrimaryHover};
    border: solid ${spacing.single} ${colors.borderPrimary};
    outline: none;

    ${IndexChip} {
      background-color: ${colors.backgroundTertiaryHover};
    }
  }

  &:active {
    background: ${colors.backgroundInteractive};
    border: solid ${spacing.single} ${colors.borderInteractive};
    box-shadow: 0 0 0 ${spacing.single} ${colors.borderInteractive};
    outline: none;

    ${IndexChip} {
      color: ${colors.textOnColor};
      background-color: ${colors.backgroundInteractiveStrong};
    }
  }

  &:focus {
    border: solid ${spacing.single} ${colors.borderInteractive};
    box-shadow: 0 0 0 ${spacing.single} ${colors.borderInteractive};
    outline: none;
  }

  &:focus-visible {
    border: solid ${spacing.single} ${colors.borderInteractive};
    box-shadow: 0 0 0 ${spacing.single} ${colors.borderInteractive};
    outline: none;
  }
`;

export const borderStyle = `${spacing.quarter} solid transparent`;

export const DragBoxContainer = styled.div`
  border-radius: ${spacing.half};
`;

type DragBoxProps = {
  isDisabled: boolean;
  leftAlignContent: boolean;
};
export const DragBox = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: ${({ leftAlignContent }: DragBoxProps) =>
    leftAlignContent ? `1fr ${spacing.base}` : `${spacing.base} 1fr`};
  ${({ isDisabled }: DragBoxProps) => (isDisabled ? '' : 'cursor: grab')};
  transition: all ${duration.short} ${easing.entrance};
`;

export const DragContent = styled.div`
  ${body2}
  margin: 0;
`;

export const DragAction = styled(Drag)``;
